import baseAxios from "./BaseApi";

class ContractCompanyApi {
  /**
   * 契約企業を検索する
   * @param {Object} params - 検索パラメータ
   * @param {string} params.name - 企業名（部分一致）
   * @param {string} params.description - 説明（部分一致）
   * @param {boolean} params.includeDeleted - 削除済みを含むかどうか
   * @param {number} params.limit - 取得件数制限
   * @param {number} params.offset - オフセット
   * @returns {Promise} API レスポンス
   */
  async searchContractCompanies(params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.name) queryParams.append('name', params.name);
    if (params.description) queryParams.append('description', params.description);
    if (params.includeDeleted !== undefined) queryParams.append('includeDeleted', params.includeDeleted);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.offset) queryParams.append('offset', params.offset);

    return baseAxios.get(`/user/contract-companies/search?${queryParams.toString()}`);
  }
}

export default new ContractCompanyApi();
